// extracted by css-extract-rspack-plugin
var _1 = "NotificationsContainer-m_container-QKPrnyWo";
export { _1 as "container" }
